// extracted by mini-css-extract-plugin
module.exports = {"mainVideoWrapper":"Video_mainVideoWrapper__24oSk","playerWrapper":"Video_playerWrapper__SOeJU","featuring":"Video_featuring__cet_t","copyIcon":"Video_copyIcon__DZY_8"};